module.exports = __webpack_public_path__ + "img/31.fixed_blockage.66f4be3f.svg";